import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenService } from '../services/authen.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
    @ViewChild('btnLogin') btnLogin: ElementRef;
    @Output() public onLoginCompleted = new EventEmitter();
    isInternalMode: boolean = true;
    userName: string;
    pwd: string;

    constructor(private auth: AuthenService, private router: Router) { }

    ngOnInit() {
    }

    onLogin() {
        let type = this.isInternalMode ? 'ZPV' : 'PRN';

        this.auth.login(this.userName, this.pwd, type, res => {
            //this.router.navigate(['/tenders-all']);
            this.onLoginCompleted.emit();
        });
    }

    onChangeLoginMode() {
        this.isInternalMode = !this.isInternalMode;
    }

    onPressEnter(evt) {
        if (evt.keyCode == 13)
            this.btnLogin.nativeElement.click();
    }
}
